<template>
    <form-row
        title="Property Images"
        :label_align_top="true"
        label_class="pt-2"
    >
        <div class="flex-1">
            <div v-for="(image, index) in images_proxy"
                class="flex-1"
                :class="index === (images_proxy.length - 1) ? '' : 'border-b border-gray-300 pb-4 mb-6'"
                :key="image.key || image.id"
            >
                <input-image
                    label="Upload an Image (10 MB Max.)"
                    :image_object="image"
                    :returns_object="true"
                    :include_link="true"
                    :store_url="image_store_url"
                    :delete_url="image?.delete_url"
                    :read_only="read_only"
                    @created="created"
                    @deleted="deleted"
                />
            </div>
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        images: {},
        image_store_url: {},
        read_only: { default: false },
    },

    data() {
        return {
            images_proxy: this.images?.length ?
                this.images.concat({ key: this.getRandomKey() })
                : [{ key: this.getRandomKey() }],
        }
    },

    methods: {
        created() {
            this.images_proxy.push({
                key: this.getRandomKey(),
            });
        },
        deleted({key, id}) {
            let index;

            if (key) {
                index = this.images_proxy.findIndex(image => image.key === key);
            } else if (id) {
                index = this.images_proxy.findIndex(image => image.id === id);
            }

            if (index > -1) {
                this.images_proxy.splice(index, 1);
            }
        },
        getRandomKey() {
            return Math.floor(Math.random() * (999999 - 1) + 1);
        },
    },
}
</script>
